import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as CheckmarkCircle } from '../../../../assets/icons/checkmark-circle.svg'
import { useLookupStore } from '../../../../stores/lookUpStore'

import styles from './add-regex.module.scss'

function AddRegex() {
    const { t } = useTranslation()

    const [, { addRegex }] = useLookupStore()

    const [name, setName] = useState('')
    const [pattern, setPattern] = useState('')

    const handleAddRegex = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()
        if (!name && !pattern) return

        addRegex({ name, pattern })
        setName('')
        setPattern('')
    }

    return (
        <form className={styles.addRegex} onSubmit={(e) => handleAddRegex(e)}>
            <input
                className={styles.addRegex__input}
                type="text"
                value={name}
                placeholder={t('name')}
                onChange={(e) => setName(e.target.value)}
            />
            <input
                className={styles.addRegex__input}
                type="text"
                value={pattern}
                placeholder={t('pattern')}
                onChange={(e) => setPattern(e.target.value)}
            />
            <button
                className={styles.addRegex__btn}
                onClick={() => handleAddRegex()}
            >
                <CheckmarkCircle
                    className={styles.addExampleTab__icon}
                    alt={t('add')}
                />
                {t('confirm')}
            </button>
        </form>
    )
}

export default AddRegex
